// Helper functions to compute initial variant defaults for an item line
// Decisions: only auto-select on first appearance; rely on colour context before size/fit.

function pickColour(item) {
  if (Array.isArray(item.colours) && item.colours.length === 1) {
    return item.colours[0].code || "";
  }
  return "";
}

function pickSize(item, colour) {
  if (!colour) return "";
  if (!Array.isArray(item.sizes) || item.sizes.length === 0) return "";
  const filtered = item.sizes.filter((s) => s.colour === colour);
  if (filtered.length === 0) return "";
  const flagged = filtered.find(
    (s) => String(s.sizeDefault).toLowerCase() === "yes",
  );
  if (flagged) return flagged.code || "";
  if (filtered.length === 1) return filtered[0].code || "";
  return "";
}

function pickFit(item, colour, size) {
  if (!colour || !size) return "";
  if (!Array.isArray(item.fits) || item.fits.length === 0) return "";
  const filtered = item.fits.filter(
    (f) => f.colour === colour && f.size === size,
  );
  if (filtered.length === 0) return "";
  const flagged = filtered.find(
    (f) => String(f.fitDefault).toLowerCase() === "yes",
  );
  if (flagged) return flagged.code || "";
  if (filtered.length === 1) return filtered[0].code || "";
  return "";
}

export function buildLineDefaults(item) {
  const colour = pickColour(item);
  const size = pickSize(item, colour);
  const fit = pickFit(item, colour, size);
  return { colour, size, fit, quantity: 0 };
}

// NOTE: We previously keyed form state by lineNo, but wardrobe items often lack lineNo.
// To ensure stable keys across initial lightweight items and enriched wardrobe items,
// we now key everything by productCode.
export function buildInitialDefaults(itemsArray) {
  return Object.fromEntries(
    itemsArray.map((it) => [it.productCode, buildLineDefaults(it)]),
  );
}

export function deriveNewLineDefaults(existingMap, latestItems) {
  const existingKeys = new Set(Object.keys(existingMap));
  const additions = latestItems.filter(
    (it) => !existingKeys.has(String(it.productCode)),
  );
  if (additions.length === 0) return null;
  return Object.fromEntries(
    additions.map((it) => [it.productCode, buildLineDefaults(it)]),
  );
}
